import React from 'react';

import { Box } from '@r-client/shared/ui/core';
import { Spinner as UISpinner } from '@r-client/shared/ui/spinner';

export const Spinner: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Box p="4brm" textAlign="center">
      <UISpinner />
    </Box>
  );
};
